<template>
	<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<rect x="5" y="10.5" width="14" height="10" rx="2.5" fill="currentColor"></rect>
		<path d="M8 10.5V8a4 4 0 018 0v2.5" stroke="currentColor" stroke-width="2.4" fill="none"></path>
	</svg>
</template>
